module.exports = __webpack_public_path__ + "static/OT-472a0a8eb2fec8ef5cbe4200925e1b61.png";